/**
 * App side of embed.js. In an inline embed the page has no viewport of its
 * own (the iframe grows to fit), so: drop full-screen min-heights, size the
 * photo stage from the host window's height, and report the content height.
 * In the full-screen overlay, Escape asks the host page to close it.
 */
export function initEmbed() {
  const embed = new URLSearchParams(location.search).get('embed');
  if (window.parent === window || (embed !== 'inline' && embed !== 'overlay')) return;

  if (embed === 'overlay') {
    addEventListener('keydown', (e) => e.key === 'Escape' && parent.postMessage({ type: 'fv:close' }, '*'));
    return;
  }

  const root = document.documentElement;
  root.classList.add('fv-embed');
  addEventListener('message', (e) => {
    if (e.source !== parent || e.data?.type !== 'fv:viewport') return;
    const h = Number(e.data.height);
    if (h > 0 && h < 10_000) root.style.setProperty('--fv-vh', `${h / 100}px`);
  });
  const app = document.getElementById('app')!;
  // Height is not sensitive, so any parent may read it ('*').
  new ResizeObserver(() => parent.postMessage({ type: 'fv:height', height: Math.ceil(app.getBoundingClientRect().height) }, '*')).observe(app);
}
